<template>
	<div class="p-d-8">
		<div>	
			<div class="d-flex-between-center align-items-start">
				<div class="d-block">
					<span class="f-regular f-14 f-c-black">Transfer</span>
					<span class="f-regular f-14 f-c-midgrey">  •  {{ tipeBayar }}</span>
				</div>
				<div class="f-regular f-14 f-c-black">
					{{ formatRupiah(pembayaran.dibayar.toString()) }}
				</div>
			</div>
			<div class="f-regular f-12 f-c-midgrey" v-if="pembayaran.rekening_owner !== null">
				Ke {{ pembayaran.rekening_owner.nama }}{{ pembayaran.rekening_owner.nomor_rekening }}
			</div>
			<div class="f-regular f-12 f-c-midgrey" v-if="pembayaran.rekening_owner === null && pembayaran.tf_bank_tujuan !== ''">
				Ke {{ pembayaran.tf_bank_tujuan }}{{ pembayaran.tf_no_rekening === '' ? '' : ' - ' + pembayaran.tf_no_rekening }}
			</div>
			<div class="f-regular f-12 f-c-midgrey" v-if="pembayaran.rekening_owner !== null">
				Atas nama: {{ pembayaran.rekening_owner }}
			</div>
			<div class="f-regular f-12 f-c-midgrey" v-if="pembayaran.rekening_owner === null && pembayaran.tf_pemilik_rekening !== ''">
				Atas nama: {{ pembayaran.tf_pemilik_rekening }}
			</div>
			<div class="f-regular f-12 f-c-midgrey">
				{{ pembayaran.waktu_bayar }} oleh {{ pembayaran.nama_karyawan }}
			</div>
		</div>
		<SOImageList
			title="Bukti Pembayaran"
			v-if="pembayaran.transaksi_foto.length"
			:images="pembayaran.transaksi_foto"
		/>
	</div>
</template>

<script>
import SOImageList from '@/so-components/global/ui/SOImageList'
export default {
	name: "SOPembayaranDebit",
	components: {
		SOImageList
	},
	props: {
		pembayaran: Object,
		tipeBayar: String,
	}
}
</script>